import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "json-text-container" }
const _hoisted_2 = {
  key: 0,
  class: "text-container expanded"
}
const _hoisted_3 = {
  key: 1,
  class: "text-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Результат", -1)),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyText && _ctx.copyText(...args)))
    }, "Скопіювати текст"),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
    }, _toDisplayString(_ctx.isExpanded ? 'Показати менше' : 'Показати більше'), 1),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isExpanded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.text), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.truncatedText), 1))
    ])
  ]))
}